import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AlertService } from '@lsq-frontend/angular-shared/features/alert-service';
import { Color, Icons, Modal, ModalServiceToken } from '@lsq-frontend/common-ui';
import { LsqValidators } from '@lsq-frontend/common-ui';
import { ModalService } from '@lsq-frontend/common-ui';

@Component({
    selector: 'upload-document-modal',
    templateUrl: './upload-document-modal.component.html',
    styleUrls: ['./upload-document-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class UploadDocumentModal {
    public megabyte = 1024 * 1024;
    public modal: Modal;
    public icons = Icons;
    public color = Color;
    public isSubmitting = false;
    public formGroup: FormGroup = this.fb.group({
        documentName: new FormControl('', Validators.required),
        documentNotes: new FormControl('', LsqValidators.maxLength(500)),
        documentFile: new FormControl('', Validators.required),
        asOfDate: new FormControl(''),
        isDateRange: new FormControl(''),
        endDate: new FormControl('')
    });
    public formGroupFile: File;
    public prospectId = '';
    public show: boolean;

    constructor(
        @Inject(ModalServiceToken) public modalService: ModalService,
        private fb: FormBuilder,
        public alertService: AlertService
    ) {
        this.modal = this.modalService.modal;
        this.prospectId = this.modal?.data.prospectId;
    }

    public onFileChange(event: any): void {
        const maximumSize: number = this.modal.data.fileSizeLimit;
        if (event.target.files.length > 0) {
            const file: File = event.target.files[0];
            if (file.size <= maximumSize * this.megabyte) {
                this.formGroupFile = event.target.files[0];
            } else {
                this.formGroup.controls['documentFile'].patchValue('');
                this.alertService.error(
                    `File size limit exceeded. Max file size is ${maximumSize}MB`
                );
            }
        }
    }

    public async confirmModal(): Promise<void> {
        this.isSubmitting = true;

        this.modal.data.uploadData.note = this.formGroup.value?.documentNotes;
        this.modal.data.uploadData.file = this.formGroupFile;
        this.modal.data.uploadData.asOfDate = this.formGroup.value?.asOfDate;
        // this.modal.data.uploadData.endDate = this.formGroup.value?.endDate;

        this.modal.onOkClick();
    }

    // public toggle() {
    //     this.show = !this.show;
    // }
}
